import styled from 'styled-components';
export const Container = styled.div`
  width: 100%;
  padding: 12px 30px;
  box-sizing: border-box;
  font-weight: 400;
  border-bottom: 1px solid #6a3ec1;
  text-transform: uppercase;
  font-size: 14px;
  background: #5e35b1;
  color: #fff;
  transition: background ease-in-out 0.2s;
  position: relative;
  &:hover {
    background: #6a3ec1;
    transition: background ease-in-out 0.2s;
  }
`;
export const IconWrapper = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  text-align: left;
  margin-right: 5px;
  position: absolute;
  right: 7px;
  top: 50%;
  margin-top: -11px;
  color: #fff;
  svg {
    width: 18px;
  }
`;
